import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useState } from 'react';
import classnames from 'classnames/bind';
import { ChevronNormalDown } from "../../../../icons";
import { ButtonBase } from "../../../../internal/ButtonBase";
import { ClickOutside } from "../../../../internal/ClickOutside";
import { Markup } from "../../../../internal/Markup";
import { TextBase } from "../../../../internal/TextBase";
import { getMethodsForTestId } from "../../../../utils/getMethodsForTestId";
import styles from './NavLinks.css';
var cx = classnames.bind(styles);
export var DropList = function DropList(_ref) {
  var index = _ref.index,
      title = _ref.title,
      insideItem = _ref.insideItem,
      isShowLayer = _ref.isShowLayer,
      namespace = _ref.namespace;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenDropList = _useState2[0],
      setIsOpenDropList = _useState2[1];

  var anchorRef = useRef();

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'navLinks'),
      getTestId = _getMethodsForTestId.getTestId;

  var handleToggler = function handleToggler() {
    setIsOpenDropList(function (prev) {
      return !prev;
    });
  };

  var handleCloseDropList = function handleCloseDropList() {
    setIsOpenDropList(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cx('dropdown')
  }, /*#__PURE__*/React.createElement("li", _extends({
    key: "nav-item-".concat(index),
    className: cx('item', 'selected-option')
  }, getTestId(index.toString(), 'item')), /*#__PURE__*/React.createElement(ButtonBase, {
    className: cx('point'),
    onClick: handleToggler,
    ref: anchorRef
  }, /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    noWrap: true
  }, /*#__PURE__*/React.createElement(Markup, {
    text: title
  })), /*#__PURE__*/React.createElement("span", {
    className: cx('dropdown-chevron', {
      'chevron-open': isOpenDropList
    })
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, null)))), isOpenDropList && /*#__PURE__*/React.createElement(ClickOutside, {
    onClickOutside: handleCloseDropList,
    ignoreRefs: [anchorRef]
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('options')
  }, insideItem === null || insideItem === void 0 ? void 0 : insideItem.map(function (item, index) {
    var CustomItem = item.as,
        href = item.href,
        itemTitle = item.title;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: index,
        className: cx('option')
      }, CustomItem && /*#__PURE__*/React.createElement(CustomItem, {
        href: href,
        title: itemTitle
      }), href && !CustomItem && /*#__PURE__*/React.createElement("a", {
        href: href,
        className: cx('dropdown-link')
      }, /*#__PURE__*/React.createElement(TextBase, {
        as: "span",
        noWrap: true
      }, /*#__PURE__*/React.createElement(Markup, {
        text: itemTitle
      }))))
    );
  }))), isShowLayer && /*#__PURE__*/React.createElement("div", {
    className: cx('layer', {
      layer_visible: isOpenDropList
    })
  }));
};